import apiClient from "../axios";
import { GetNotificationsParams } from "./notification.hooks";

export const getNotifications = async (params: GetNotificationsParams) => {
  const res = await apiClient.get(
    `${process.env.EXPO_PUBLIC_BLOCKS_BASE_URL}/communication/v1/Notifier/GetNotifications`,
    { params },
  );
  return res.data;
};

export const markNotificationAsRead = async (id: string) => {
  const res = await apiClient.post(
    `${process.env.EXPO_PUBLIC_BLOCKS_BASE_URL}/communication/v1/Notifier/MarkNotificationAsRead`,
    { id },
  );
  return res.data;
};

export const markAllNotificationAsRead = async () => {
  const res = await apiClient.post(
    `${process.env.EXPO_PUBLIC_BLOCKS_BASE_URL}/communication/v1/Notifier/MarkAllNotificationAsRead`,
    {},
  );
  return res.data;
};

export const sendNotification = async (payload: {
  userIds: string[];
  configuratoinName: string;
  denormalizedPayload: string;
  responseKey?: string;
  responseValue?: string;
  roles?: string[];
  connectionId?: string;
}) => {
  const res = await apiClient.post(
    `${process.env.EXPO_PUBLIC_BLOCKS_BASE_URL}/communication/v1/Notifier/Notify`,
    {
      connectionId: "",
      roles: [""],
      ...payload,
    },
  );
  return res.data;
};
